<script setup>
import CreateWallet from './CreateWallet.vue';
import AccessWallet from './AccessWallet.vue';
import { toRefs } from 'vue';

const emit = defineEmits(['import-wallet']);

const props = defineProps({
    advancedMode: Boolean,
});
const { advancedMode } = toRefs(props);
const importLock = defineModel('importLock');

function importWallet(importObj) {
    if (!importLock.value) {
        importLock.value = true;
        emit('import-wallet', importObj);
    }
}
</script>

<template>
    <div
        class="row m-0 justify-content-center"
        data-testid="loginCardGrid"
    >
        <CreateWallet
            :advanced-mode="advancedMode"
            @import-wallet="
                (mnemonic, password, label, blockCount) =>
                    importWallet({
                        type: 'hd',
                        secret: mnemonic,
                        password,
                        blockCount,
                        label,
                    })
            "
            :import-lock="importLock"
        />

        <AccessWallet
            :advancedMode="advancedMode"
            @import-wallet="
                (secret, password, label) =>
                    importWallet({ type: 'hd', secret, password, label })
            "
        />
    </div>

    <div class="row m-0 justify-content-center">
        <div class="col-12 col-xl-8 p-2">
            <div class="wallet-instructions">
                <h4 class="wallet-instructions-title">Getting started</h4>
                <p>
                    <span class="step">1.</span> The 1776CASH online wallet
                    <strong>DOES NOT</strong> sync with your desktop 1776CASH
                    wallet.
                </p>
                <p>
                    <span class="step">2.</span> Create an online wallet and
                    save your seed phrase — save this in a place to retrieve.
                </p>
                <p>
                    <span class="step">3A.</span> On
                    <a
                        href="https://freedom.buzz/1776cash"
                        target="_blank"
                        rel="noopener noreferrer"
                        >www.Freedom.buzz</a
                    >
                    obtain 76 free 1776CASH coins
                </p>
                <p class="or">or</p>
                <p>
                    <span class="step">3B.</span> Purchase or trade from the
                    cryptocurrency exchanges 1776CASH is sold or traded
                </p>
                <p class="or">or</p>
                <p>
                    <span class="step">3C.</span> Trade another cryptocurrency
                    on a DEX that 1776CASH is traded on
                </p>
                <p>
                    <span class="step">4A.</span> Copy your 1776CASH payment
                    address from the online wallet and fund your 1776CASH
                    online wallet from the exchange — so that you can make
                    purchases from
                    <a
                        href="https://localfoods.market"
                        target="_blank"
                        rel="noopener noreferrer"
                        >LocalFoods.market</a
                    >,
                    <a
                        href="https://healing.tube"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Healing.tube</a
                    >
                    or
                    <a
                        href="https://lamarslist.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        >LamarsList.com</a
                    >
                </p>
                <p class="or">or</p>
                <p>
                    <span class="step">4B.</span> If you claim 76 free 1776CASH
                    coins from
                    <a
                        href="https://freedom.buzz/1776cash"
                        target="_blank"
                        rel="noopener noreferrer"
                        >https://freedom.buzz/1776cash</a
                    >, copy your 1776CASH payment address from the online
                    wallet and fund your 1776CASH online wallet — by pasting
                    your 1776CASH online wallet payment address within the
                    payment address space on
                    <a
                        href="https://freedom.buzz/1776cash"
                        target="_blank"
                        rel="noopener noreferrer"
                        >https://freedom.buzz/1776cash</a
                    >
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped>
.wallet-instructions {
    background: var(--theme-surface, #ffffff);
    border: 1px solid var(--theme-border, #bfc6db);
    border-radius: 14px;
    padding: 24px 28px;
    color: var(--theme-text, #1b2249);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1);
}

.wallet-instructions-title {
    color: var(--theme-accent, #2c4f91);
    font-weight: 700;
    margin-bottom: 14px;
}

.wallet-instructions p {
    margin-bottom: 8px;
    line-height: 1.55;
}

.wallet-instructions .step {
    color: var(--theme-accent, #2c4f91);
    font-weight: 700;
    margin-right: 6px;
}

.wallet-instructions .or {
    margin: 2px 0 2px 26px;
    color: var(--theme-text-muted, #5c648a);
    font-style: italic;
}

.wallet-instructions a {
    color: var(--theme-accent-2, #405ea6);
    font-weight: 600;
    word-break: break-all;
}

.wallet-instructions a:hover {
    text-decoration: underline;
}
</style>
